export const getFairgames = state => {
  const fairgames = state.fairgames.fairgames.data || []
  return fairgames
}
export const getVerifiedGame = state => {
  const verified = state.fairgames.verified.data || []
  return verified
}
